export const ImageConstants = {
  IMAGE_NOT_AVAILABLE: 'image-not-available.webp',
}
